import React from 'react';
import { Box, styled, Typography, useTheme } from '@mui/material';
import Row from '../../../Row';

interface Props {
  dataKey: string | number | undefined;
  color: string;
  opacity?: number;
  label: string;
  value: string;
  xAxis: string;
}

const TooltipValue: React.FC<Props> = ({ dataKey, color, value, label, opacity = 1 }) => {
  const theme = useTheme();
  return (
    <CustomRow key={dataKey} color={color} opacity={opacity}>
      <Box component="div" />
      <Typography style={{ marginRight: theme.spacing(1) }} variant="body2">
        {label}:
      </Typography>

      <Typography style={{ fontWeight: 600 }} variant="body2">
        {value}
      </Typography>
    </CustomRow>
  );
};

export default TooltipValue;

const CustomRow = styled(Row)<{ color: string; opacity: number }>(({ theme, color, opacity }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(1),
  '&>div': {
    backgroundColor: color,
    opacity: opacity,
    height: 10,
    width: 10,
    marginTop: theme.spacing(0.8),
    marginRight: theme.spacing(1),
  },
  '&>p': {
    fontSize: '14px',
    color: 'white',
  },
}));
